import { createActions } from 'redux-actions';

import { CancerQuote, CancerQuoteList } from '@models/CancerQuote';
import { CancerQuoteGroup } from '@models/CancerQuoteGroup';
import { GetAllCancerQuoteParams } from '@apis/CancerQuoteApi';

export type State = {
  totalQuotes?: number | null;
  cancerQuoteGroups?: CancerQuoteGroup[] | null;
  comparableCancerQuotes: CancerQuote[];
};

export type CancerQuotesFetchPayload = GetAllCancerQuoteParams;
export type CompareAddPayload = { cancerQuote: CancerQuoteList };
export type CompareRemovePayload = CompareAddPayload;
export type StateUpdatePayload = Partial<State>;

export const {
  cancerQuotesFetch,
  compareAdd,
  compareRemove,
  compareRemoveAll,
  stateUpdate,
} = createActions(
  'CANCER_QUOTES_FETCH',
  'COMPARE_ADD',
  'COMPARE_REMOVE',
  'COMPARE_REMOVE_ALL',
  'STATE_UPDATE',
  {
    prefix: 'CANCER_QUOTE_RESULT_PAGE',
  },
);
